import Vue from 'vue'
import Component from 'vue-class-component'

import store from "@/store";
import User from "@/lib/models/User";

// Define the component in class-style
@Component
export default class userMixin extends Vue {


    get isLoggedIn(): boolean {
        return this.$store.state.user !== null;
    }


    get isUserVerified(): boolean {
        return this.$store.state && this.$store.state.verified;
    }


    get loggedUser(): User {
        return this.$store.state.user;
    }


    reloadUser(loggedUser: User, callback: () => void) {
        // @ts-ignore
        this.$firebase.database().ref('/users/' + loggedUser.uid).once('value').then((snapshot) => {

            const user = (new User()).fromObject(Object.assign({}, {
                uid: loggedUser.uid,
                email: loggedUser.email,
            }, snapshot.val()));
            store.commit('updateUser', user);
            callback();
        });
    }

}
